enum ENivelUsuarioAPI {
  Administrador = 'Administrador',
  Desenvolvedor = 'Desenvolvedor',
  Suporte = 'Suporte',
  Comercial = 'Comercial',
  Indefinido = '',
}
export default ENivelUsuarioAPI;
